export default {
  TOGGLE_LOADING(state) {
    state.callingAPI = !state.callingAPI;
  },
  TOGGLE_SEARCHING(state) {
    state.searching = state.searching === "" ? "loading" : "";
  },
  SET_USER(state, user) {
    state.user = user;
  },
  SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_DEVICETOKEN(state, devicetoken) {
    state.devicetoken = devicetoken;
  },
  TOGGLE_FULLSCREEN_LOADING(state) {
    state.isLoading = !state.isLoading;
  },
  SET_FULLSCREEN_LOADING(state) {
    state.isLoading = true;
  },
  UNSET_FULLSCREEN_LOADING(state) {
    state.isLoading = false;
  },
  SET_ERROR(state, message) {
    state.errorMessage = message;
  },
  UNSET_ERROR(state) {
    state.errorMessage = "";
  }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js